import { render, staticRenderFns } from "./project-onSale.vue?vue&type=template&id=75ccccc6&scoped=true&"
import script from "./project-onSale.vue?vue&type=script&lang=js&"
export * from "./project-onSale.vue?vue&type=script&lang=js&"
import style0 from "./project-onSale.vue?vue&type=style&index=0&id=75ccccc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ccccc6",
  null
  
)

export default component.exports